module.exports = __webpack_public_path__ + "img/logo.d4987dd1.png";